import { BomItemPointer } from 'model/Project/BomItemPointer'
import { CSSProperties } from 'react'
import { useAppSelector } from 'store/configureStore'
import { AnimalScaleIcon } from './AnimalScaleIcon'
import { bomItemScaleSelector } from './bomItemScaleSelector'

export const BomItemScaleIcon = (props: {
  bomItemPointer: BomItemPointer
  baseStyle?: CSSProperties
}) => {
  const scale = useAppSelector(bomItemScaleSelector(props.bomItemPointer))

  if (!scale) {
    return null
  }

  return (
    <div style={{ ...(props.baseStyle || {}) }}>
      <AnimalScaleIcon scale={scale} />
    </div>
  )
}
